import { createContext } from "react";

const ArticuloContext = createContext();

export default ArticuloContext;